import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;
export const ASSET_BASE = BACKEND;
export function fileUrl(u) {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${BACKEND}${u}`;
}

const client = axios.create({ baseURL: API_BASE, withCredentials: true });

export default client;

export function formatErr(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
